/**
 * Vee-Validate
 *
 * @since: 2018-03-24
 * @author: kdydesign.kim
 */

import VeeValidate, {Validator} from 'vee-validate'
import CustomRule from './customRules'
import Config from './validateConfig'

export default {
  // TAMS
  install (Vue, options = {}) {
    Vue.use(VeeValidate, Config)

    // custom rule
    CustomRule(Validator)
  }
}
